<template>
  <main id="apply-list">
    <BottomBar />
    <Modal
      v-if="components.status"
      v-on:dismiss="components.status = false"
      :showComplete="false"
      :showClose="true"
      :tapToDismiss="true"
    >
      <Status
        @dismiss="components.status = false"
        @question="components.question = true"
        :data="components.status"
      />
    </Modal>
    <Modal
      v-if="components.question"
      v-on:dismiss="components.question = false"
      title="关于补贴"
      :showComplete="false"
      :showClose="true"
      :tapToDismiss="true"
    >
      <Question />
    </Modal>
    <div class="top">
      <h1>优学卡店家入驻</h1>
      <p>「王冰暗示法英语」是 AnyTeach 约课平台旗下的招牌英语课程，独创暗示法教学法，提出 250 小时学完中学六年全部英语，以快速提分、不刷题海、整体教学为特点，由平台的上千名暗示法名师提供 1 对 3 线上小班教学。平台现推出优学卡合作方案，以促进顾客在合作店家消费，保持后续消费以及提升合作店家的顾客到访量。</p>
      <img src="https://anyteach.oss-cn-shanghai.aliyuncs.com/store-gift/store-process.jpg" />
      <router-link tag="div" class="button" to="/store-gift/apply/new">
        <i class="anyteachicon anyteach-plus1" />
        <span>新店申请入驻</span>
      </router-link>
    </div>
    <section v-if="list.length" class="padding">
      <h3>已申请</h3>
      <Item @view="components.status = item" v-for="item in list" :key="item.id" :data="item" />
    </section>
  </main>
</template>

<script>
import Item from "./Item"
import Status from "./Status"
import Question from "./Question"
export default {
  name: "ApplyList",
  components: {
    Item,
    Status,
    Question
  },
  computed: {
    query() {
      return this.$route.query
    }
  },
  data() {
    return {
      components: {
        status: false,
        question: false
      },
      list: []
    }
  },
  methods: {
    async getList() {
      const { code, msg } = await this.$api.storeGift.STORE_LIST()
      if (code === "1000") {
        this.list = msg
        if (this.query.store_id) {
          this.components.status = this.list.find(item => Number(item.id) === Number(this.query.store_id))
        }
      }
    }
  },
  created() {
    this.getList()
    this.$wxShare({
      title: "优学卡店家入驻",
      desc: "想要不花一分钱提升顾客消费和到访量？点击申请免费合作 →",
      link: location.origin + this.$route.path,
      imgUrl: window.logo2019
    })
  }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
#apply-list {
  .top {
    margin-bottom: 10px;
    padding-bottom: 15px;
  }
  .button {
    width: 100%;
    i {
      margin-right: 3px;
    }
  }
}

section {
  margin: 15px 0 0 0;
  h3 {
    font-size: 0.8rem;
    font-weight: 400;
    opacity: 0.6;
  }
}
</style>